import React from "react";
import * as XLSX from "xlsx";

const ExportToExcel = ({ data, fileName }) => {
  const exportToExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Categories");

    // Write the workbook to a file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <button
      onClick={exportToExcel}
      className="px-3 py-2 text-xs font-medium bg-green-500 text-white rounded-md hover:bg-green-700"
    >
      Export to Excel
    </button>
  );
};

export default ExportToExcel;
